import {
  Button,
  ContextMenu,
  Icon,
  Li,
  Link,
  Loading,
  LoadingDiv,
  Tooltip
} from '@startlibs/components';
import { TextInput } from '@startlibs/form'
import { callIfFunction, getColor, isMobile, media } from '@startlibs/utils';
import { useConstant, usePopupToggle, useToggle } from '@startlibs/core';
import React, { useEffect, useMemo, useState } from 'react';
import _ from 'lodash/fp';
import styled from 'styled-components';
import { BoxPageContainer, BoxPageLayout, BoxPageWrapper, BoxWrapperHeading } from '../../components/BoxPageLayout';
import { DATE_FORMAT } from '../../config/DateFormat'
import {
  DropdownButton,
  StyledExpertTable,
  StyledRow,
  StyledTable,
  StyledTableHead,
  TextButton
} from '../../components/StyledTable'
import { NotProvided } from '../steps/ExpertAssignmentStep'
import { Pagination } from '../../components/Pagination'
import { PurviewFooter } from '../../components/PurviewFooter';
import { filterExpert, formatDateNoUTC, searchToParams } from '../../utils/utils'
import { getJwt } from '../../hooks/useJwt'
import { jwtGetFetcher } from '../../utils/authFetch'
import { useDeleteExpertDialog } from './hooks/useDeleteExpertDialog'
import { useResetExpertPasswordDialog } from './hooks/useResetExpertPasswordDialog'
import { willUseSuspense } from '../../hooks/useSuspense'
import { IfLocale } from '../../hocs/IfLocale'
import { lazyProviderInfo } from '../../components/WithProvider';
import { LoadingPage } from '../../components/PageLoading';
import { Card } from '../../components/PageLayout';
import { LoadingTableContent } from '../controlPanel/staff/Table';
import { useLocation } from 'react-router';
import { callUpdateParams, useUpdateParams, useUpdateUrl } from '../../hooks/useQueryParams';
import { isNumber } from 'lodash';

const ExpertBrowserPage = styled(BoxPageLayout)`
  .heading-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem 2rem;
  }
  ${StyledTable} {
    overflow: visible;
  }
  ${StyledTableHead} {
    position: sticky;
    top: 0;
    z-index: 3;
    background: white;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  ${StyledRow} {
    > div {
      &.name {
        flex-basis: 190px;
        min-width: 140px;
        max-width: 210px;
      }
      &.email {
        flex-grow: 1;
        flex-basis: 180px;
        min-width: 140px;
        max-width: 200px;
      }
      &.specialities {
        flex-grow: 1;
        flex-basis: 180px;
        min-width: 140px;
        max-width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        white-space: nowrap;
        > div {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }
      }
      &.date-added {
        flex-basis: 84px;
        min-width: 84px;
      }
      &.cases-count {
        flex-basis: 85px;
        min-width: 54px;
      }
      &.actions {
        flex-basis: 160px;
        min-width: 160px;
        .wide-only {
          margin-left: .25rem;
        }
      }
    }
    &:last-child {
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    ${media.max(960)`
      > div.actions {
        min-width: 160px;
      }
      .wide-only {
        display: none;
      }
    `}
  }
  ${media.max(840)`
    ${StyledRow} {
      > div {
        &.cases-count {
          position: absolute;
          top: 1.5rem;
          right: 1.5rem;
          border-radius: 5px;
          background-color: rgba(0,0,0,0.05);
          padding: .25rem .5rem;
          text-align: right;
          &:before {
            content: "Open cases: ";
            font-size: 13px;
            display: inline;
          }
        }
        &.name {
          font-size: 1.75rem;
          margin-bottom: .75rem;
          padding-right: 110px;
          max-width: 100%;
          &:before {
            content: "Name: ";
            font-size: 13px;
            display: block;
          }
        }
        &.email {
          margin-bottom: .75rem;
          &:before {
            content: "Email: ";
          }
        }
        &.specialities {
          min-width: 0;
          max-width: 100%;
        }
        &.date-added {
          display: block;
          padding-bottom: 1.5rem;
          &:before {
            content: "Added on: ";
          }
        }
      }
  `}
  ${media.max(520)`
    .heading-actions {
      flex-wrap: wrap;
      ${Button} {
        margin-top: 1rem;
        margin-left: auto;
      }
    }
    ${StyledRow} {
      > div {
        &.cases-count {
          position: absolute;
          bottom: 4rem;
          right: 2rem;
          top: auto;
          text-align: right;
          padding: 0 0 .25rem;
          margin-bottom: 1rem;
          background: transparent;
          border-radius: 0;
          &:before {
            display: block;
          }
        }
        &.name {
          padding-right: 0;
        }
      }
    }
  `}
}
`


const EmptyListPlaceholder = styled.div`
  padding: 5rem 1rem;
  text-align: center;
  background-color: rgba(0,0,0,0.05);
  color: rgba(0,0,0,0.6);
  font-size: 14px;
  font-weight: 600;
  ${props => props.onDialog && `
    padding: 2rem 1rem;
    margin-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: 0;
    font-size: 13px;
  `}
`

export const PaginationWrapper = styled.div`
  margin-top: 1.5rem;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LinkButton = styled.a`
  position: relative;
  display: inline-block;
  text-decoration: underline;
  user-select: none;
`

const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${getColor('gray120')};
  flex-grow: 1;
  .query-count {
    b {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 10rem;
      width: 100%;
      display: block;
    }
  }
  ${media.max(910)`
    display: block;
    .query-count {
      position: absolute;
      top: -1rem;
      right: 0;
    }
  `}
`
const SearchInput = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 1rem;
  width: 24rem;
  ${media.max(910)`
    margin-right: 0;
    margin-bottom: .5rem;
    max-width: 100%;
    width: 100%;
  `}
  ${props => props.expandedInput && `
    > input {
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  `}
`

const ClearSearchButton = styled(Icon)`
  color: ${getColor('gray90')};
  font-size: 12px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  border-radius: 50%;
  background: rgba(0,0,0,0.1);
  :hover {
    background: #f7d3d4;
    color: ${getColor('alert')};
  }
`

const MaxResultsMenu = styled(ContextMenu)`
  li > * {
    padding: 11px 2rem;
  }
`

// const useAuthSuspense = willUseSuspense(() =>
//   // jwtGetFetcher(getJwt())(`/api/experts`)
//   jwtGetFetcher(getJwt())(`/api/searchExperts?first=0&rows=10`).then((response) => response.list)
// )

export const ExpertList = () => {

  const location = useLocation()
  const [experts, setExperts] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [count, setCount] = useState(0)
  const [totalPages, setTotalPages] = useState(0)


  const [params, rawSetParams] = useState(() => searchToParams(location.search))


  const updateParams = (params) => {
    rawSetParams(params)
    callUpdateParams(params)
  }

  const debounceSetParams = useConstant(_.debounce(200, rawSetParams))

  const setParams = (updater, debounce) => {
    const verifyPage = (updater) => (state) => {
      const updatedState = callIfFunction(updater, state)
      if (
        state.search !== updatedState.search
      ) {
        return _.set('page', 1, updatedState)
      } else if (state.maxResults !== updatedState.maxResults) {
        const firstRow = ((state.maxResults || 10) * (updatedState.page - 1) + 1)
        return _.set('page', Math.max(Math.floor(firstRow / (updatedState.maxResults || 10)) + 1, 1), updatedState)
      } else {
        return updatedState
      }
    }
    if (debounce) {
      debounceSetParams(verifyPage(updater))
    } else {
      setTimeout(() => rawSetParams(verifyPage(updater)), 0)
    }
    setIsLoading(true)
  }

  const query = useToggle(params.search || '')
  const maxResults = useToggle(params.maxResults || '')
  const contextMenu = usePopupToggle()
  const currentPage = Number(params.page) || 1


  const updateUrl = useUpdateUrl()

  useUpdateParams((params) => {
    query.openWith(params.search || "")
    maxResults.openWith(params.maxResults || "")
  })

  useEffect(() => {
    updateUrl(params)
  }, [params])





  const maxResultsMenu = usePopupToggle()
  const advancedPopup = useToggle()

  const updateSearch = (v) => {
    query.openWith(v)
    setParams(_.set('search', v), true)
  }

  const updateMaxResult = (v) => {
    maxResults.openWith(v)
    setParams(_.set('maxResults', v), true)
  }


  useEffect(() => {
    setIsLoading(true)
    const URLSafeSearch = params.search ? encodeURIComponent(params.search) : ''
    const maxResults = params.maxResults || 10
    const first = maxResults && params.page ? maxResults * (params.page - 1) : 0
    jwtGetFetcher(getJwt())(`/api/searchExperts?first=${first}&rows=${maxResults}${params.search ? `&search=${URLSafeSearch}` : ''}`)
      .then((response) => {
        setExperts(response.list)
        setTotalPages(Math.ceil((Number(response.count)) / (maxResults)))
        setCount(response.count)
      })
      .finally(() => setIsLoading(false))
  }, [params])

  return <ExpertBrowserPage>
    <BoxPageContainer>
      <BoxPageWrapper>
        <BoxWrapperHeading className="heading-actions">
          {/* <SearchInput>
              <Icon icon="search"/>
              <TextInput raw value={searchTerm} setValue={setSearchTerm} placeholder="Search"/>
            </SearchInput>
            <Button.Link highlight icon="plus-circle" to="new">Add expert</Button.Link> */}
          <div className="left-wrapper">
            <div className="flex-wrapper">
              <SearchInputWrapper>
                <SearchInput >
                  <TextInput raw value={query.isOpen} setValue={updateSearch} placeholder="Search experts" />
                  {query.isOpen && <ClearSearchButton icon="x" onClick={() => updateSearch("")} />}
                </SearchInput>
                <div className="query-count">
                  <b>{count} {count === 1 ? "expert" : "experts"}</b>

                  <div className="nowrap">Showing <LinkButton onClick={maxResultsMenu.open}>{(maxResults.isOpen || 10)} per page
                    {
                      maxResultsMenu.isOpen &&
                      <MaxResultsMenu offset="0 4">
                        <Li label="10" onClick={() => updateMaxResult('')} />
                        <Li label="25" onClick={() => updateMaxResult(25)} />
                        <Li label="50" onClick={() => updateMaxResult(50)} />
                      </MaxResultsMenu>
                    }
                  </LinkButton>
                  </div>
                </div>
              </SearchInputWrapper>
            </div>
          </div>
          <div className="right-wrapper">
            <Button.Link highlight icon="plus-circle" to="new">Add expert</Button.Link>
          </div>
        </BoxWrapperHeading>
        {
          // isLoading 
          //   ? <Card style={{ height: "100%" }}>
          //       <Loading size={40} style={{ margin: "4rem auto" }} />
          //   </Card> : 
          <StyledExpertTable isLoading={isLoading} isMobile={isMobile()}>
            <StyledTableHead>
              <div className="name">Name</div>
              <div className="email">Email</div>
              <IfLocale not contains="LEGAL"><div className="specialities">Specialties</div></IfLocale>
              <div className="date-added">Added on</div>
              <div className="cases-count">Open cases</div>
              <div className="actions" />
            </StyledTableHead>
            {
              experts.length > 0 && experts.map(expert => <ExpertRow setExperts={setExperts} expert={expert} key={expert.id} />)
            }
            {isLoading &&
              <LoadingTableContent isMobile={isMobile()} withMinHeight={experts.length < 3}><Loading absolute size={40} borderWidth={6} /></LoadingTableContent>
            }
            {!isLoading && experts.length === 0 &&
              <EmptyListPlaceholder>
                {experts.length === 0 && params.search !== '' &&
                  <span>There are no experts matching your search criteria.</span>}
                {experts.length === 0 && params.search === '' && <span>There are no experts registered in this system yet.</span>}
              </EmptyListPlaceholder>
            }
          </StyledExpertTable>
        }
        <PaginationWrapper>
          {/* <Pagination setPageParam={(page) => () => setPage(page)}
                      currentPage={page}
                      totalPages={totalPages}/> */}
          <Pagination setPageParam={(page) => () => setParams(_.set('page', page))}
            currentPage={currentPage}
            totalPages={totalPages} />
        </PaginationWrapper>
      </BoxPageWrapper>
    </BoxPageContainer>
    <PurviewFooter />
  </ExpertBrowserPage>
}

const ExpertRow = ({ expert, setExperts }) => {

  const providerInfo = lazyProviderInfo.read()

  const openResetPassword = useResetExpertPasswordDialog(expert)
  const openDeleteDialog = useDeleteExpertDialog(expert, () => setExperts(_.without([expert])))
  const contextMenu = usePopupToggle()

  const dateAdded = formatDateNoUTC(new Date(expert.whenCreatedEpochMilli), DATE_FORMAT())
  const expertName = expert.firstName + " " + expert.lastName

  return <StyledRow>
    <div className="name">{expertName.length > 2 ? expertName : <NotProvided />}</div>
    <div className="email">{expert.expertEmail}</div>
    <IfLocale not contains="LEGAL"><div className="specialities">
      {(expert.specialization || []).join(", ").length > 0 &&
        <Tooltip whenEllipsis={({ target }) => target.offsetWidth < target.scrollWidth} content={(expert.specialization || []).join(", ")}>
          {(expert.specialization || []).join(", ")}
        </Tooltip>
      }
    </div></IfLocale>
    <div className="date-added">{dateAdded}</div>
    <div className="cases-count">{expert.openCases}</div>
    <div className="actions">
      <TextButton as={Link} to={`view/${expert.id}`}>View</TextButton>
      <TextButton as={Link} to={`edit/${expert.id}`}>Edit</TextButton>
      <DropdownButton onClick={contextMenu.open}>
        <Icon icon="arrow-down" />
        {
          contextMenu.isOpen && <ContextMenu>
            <Li label="Remove expert" onClick={openDeleteDialog} />
            {((!providerInfo.ssoEnabled) || expert.expertEmail.indexOf('@purview') >= 0) ? <Li label="Reset password" onClick={openResetPassword} /> : null}
          </ContextMenu>
        }
      </DropdownButton>
    </div>
  </StyledRow>
}
